<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss" scoped>
#app {
  width: 100vw;
  height: 100vh;
  background-color: #030934;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue